module.exports = __webpack_public_path__ + "assets/date-78aa35.svg";